/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  WithRatingName,
  WithRatingNameOptional,
  WithRatingNameMetaI,
  WithRatingNameTrackedI,
} from "./with-rating-name";
import { WithRatingNameTracked, WithRatingNameMeta } from "./with-rating-name";

/**
 *
 * @export
 * @interface RatingBase
 */
export interface RatingBaseOptional extends WithRatingNameOptional {
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingName?: string;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMinCrew?: number;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMaxCrew?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  testable?: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingCategory?: string;
}

export interface RatingBase extends RatingBaseOptional, WithRatingName {
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingName?: string;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMinCrew?: number;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMaxCrew?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  testable?: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingCategory?: string;
}

export interface RatingBaseTrackedI extends WithRatingNameOptional {
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingName?: string;
  ratingNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMinCrew?: number;
  testMinCrewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingBase
   */
  testMaxCrew?: number;
  testMaxCrewIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingBase
   */
  testable?: boolean;
  testableIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingBase
   */
  ratingCategory?: string;
  ratingCategoryIsSet: boolean;
}

transformDatesMap.set("RatingBase", function (model: RatingBase) {});

export type RatingBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  ratingName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  testMinCrew: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  testMaxCrew: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  testable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  ratingCategory: PropertyMeta<MetaTypeBase<string>>;
}>;

export var RatingBaseMeta: RatingBaseMetaI = {} as RatingBaseMetaI;
RatingBaseMeta = typeMeta("RatingBase", {
  ratingName: propertyMeta(
    "ratingName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  testMinCrew: propertyMeta(
    "testMinCrew",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  testMaxCrew: propertyMeta(
    "testMaxCrew",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  testable: propertyMeta(
    "testable",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  ratingCategory: propertyMeta(
    "ratingCategory",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = RatingBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithRatingNameMeta]);
  metaI.ratingName.inheritedFrom = WithRatingNameMeta.ratingName;
});

export class RatingBaseTracked
  extends WithRatingNameTracked
  implements RatingBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  ratingName__I?: string = undefined;
  ratingNameIsSet: boolean = false;
  set ratingName(v: undefined | string) {
    if (v !== undefined) {
      this.ratingName__I = v;
      this.ratingNameIsSet = true;
    } else {
      this.ratingName__I = v || undefined;
      this.ratingNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingName() {
    return this.ratingName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  testMinCrew__I?: number = undefined;
  testMinCrewIsSet: boolean = false;
  set testMinCrew(v: undefined | number) {
    if (v !== undefined) {
      this.testMinCrew__I = v;
      this.testMinCrewIsSet = true;
    } else {
      this.testMinCrew__I = v || undefined;
      this.testMinCrewIsSet = false;
    }
    this.changeTracker = true;
  }
  get testMinCrew() {
    return this.testMinCrew__I;
  }
  testMaxCrew__I?: number = undefined;
  testMaxCrewIsSet: boolean = false;
  set testMaxCrew(v: undefined | number) {
    if (v !== undefined) {
      this.testMaxCrew__I = v;
      this.testMaxCrewIsSet = true;
    } else {
      this.testMaxCrew__I = v || undefined;
      this.testMaxCrewIsSet = false;
    }
    this.changeTracker = true;
  }
  get testMaxCrew() {
    return this.testMaxCrew__I;
  }
  testable__I?: boolean = undefined;
  testableIsSet: boolean = false;
  set testable(v: undefined | boolean) {
    if (v !== undefined) {
      this.testable__I = v;
      this.testableIsSet = true;
    } else {
      this.testable__I = v || undefined;
      this.testableIsSet = false;
    }
    this.changeTracker = true;
  }
  get testable() {
    return this.testable__I;
  }
  ratingCategory__I?: string = undefined;
  ratingCategoryIsSet: boolean = false;
  set ratingCategory(v: undefined | string) {
    if (v !== undefined) {
      this.ratingCategory__I = v;
      this.ratingCategoryIsSet = true;
    } else {
      this.ratingCategory__I = v || undefined;
      this.ratingCategoryIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingCategory() {
    return this.ratingCategory__I;
  }
  constructor(config?: RatingBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: RatingBaseOptional,
    options?: AssignOptions,
  ): RatingBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.ratingName &&
      this.ratingNameApplyFilter(optionsRequired.filter)
    ) {
      this.ratingName = config.ratingName;
      if (optionsRequired.unassign) this.ratingNameIsSet = false;
      else this.ratingNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.testMinCrew &&
      this.testMinCrewApplyFilter(optionsRequired.filter)
    ) {
      this.testMinCrew = config.testMinCrew;
      if (optionsRequired.unassign) this.testMinCrewIsSet = false;
      else this.testMinCrewIsSet = true;
    }
    if (
      config.testMaxCrew &&
      this.testMaxCrewApplyFilter(optionsRequired.filter)
    ) {
      this.testMaxCrew = config.testMaxCrew;
      if (optionsRequired.unassign) this.testMaxCrewIsSet = false;
      else this.testMaxCrewIsSet = true;
    }
    if (config.testable && this.testableApplyFilter(optionsRequired.filter)) {
      this.testable = config.testable;
      if (optionsRequired.unassign) this.testableIsSet = false;
      else this.testableIsSet = true;
    }
    if (
      config.ratingCategory &&
      this.ratingCategoryApplyFilter(optionsRequired.filter)
    ) {
      this.ratingCategory = config.ratingCategory;
      if (optionsRequired.unassign) this.ratingCategoryIsSet = false;
      else this.ratingCategoryIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): RatingBaseTrackedI {
    const cloned = {} as RatingBaseTrackedI;
    if (
      this.ratingNameIsSetDeep() &&
      this.ratingNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingNameIsSet = true;
      cloned.ratingName = this.ratingName;
    } else {
      //cloned.ratingNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.testMinCrewIsSetDeep() &&
      this.testMinCrewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testMinCrewIsSet = true;
      cloned.testMinCrew = this.testMinCrew;
    } else {
      //cloned.testMinCrewIsSet = false
    }
    if (
      this.testMaxCrewIsSetDeep() &&
      this.testMaxCrewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testMaxCrewIsSet = true;
      cloned.testMaxCrew = this.testMaxCrew;
    } else {
      //cloned.testMaxCrewIsSet = false
    }
    if (
      this.testableIsSetDeep() &&
      this.testableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testableIsSet = true;
      cloned.testable = this.testable;
    } else {
      //cloned.testableIsSet = false
    }
    if (
      this.ratingCategoryIsSetDeep() &&
      this.ratingCategoryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingCategoryIsSet = true;
      cloned.ratingCategory = this.ratingCategory;
    } else {
      //cloned.ratingCategoryIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): RatingBaseTrackedI {
    if (!this.ratingNameApplyFilter(filter)) this.ratingNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.testMinCrewApplyFilter(filter)) this.testMinCrewIsSet = false;

    if (!this.testMaxCrewApplyFilter(filter)) this.testMaxCrewIsSet = false;

    if (!this.testableApplyFilter(filter)) this.testableIsSet = false;

    if (!this.ratingCategoryApplyFilter(filter))
      this.ratingCategoryIsSet = false;

    return this;
  }
  ratingNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingBaseMeta.ratingName,
      RatingBaseMeta,
      this.ratingName,
      this,
    );
  }
  ratingNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingNameIsSet && this.ratingNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingBaseMeta.displayOrder,
      RatingBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingBaseMeta.active, RatingBaseMeta, this.active, this);
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  testMinCrewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingBaseMeta.testMinCrew,
      RatingBaseMeta,
      this.testMinCrew,
      this,
    );
  }
  testMinCrewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testMinCrewIsSet && this.testMinCrewApplyFilter(filter))
      return true;

    return false;
  }
  testMaxCrewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingBaseMeta.testMaxCrew,
      RatingBaseMeta,
      this.testMaxCrew,
      this,
    );
  }
  testMaxCrewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testMaxCrewIsSet && this.testMaxCrewApplyFilter(filter))
      return true;

    return false;
  }
  testableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingBaseMeta.testable, RatingBaseMeta, this.testable, this);
  }
  testableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testableIsSet && this.testableApplyFilter(filter)) return true;

    return false;
  }
  ratingCategoryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingBaseMeta.ratingCategory,
      RatingBaseMeta,
      this.ratingCategory,
      this,
    );
  }
  ratingCategoryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingCategoryIsSet && this.ratingCategoryApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.ratingNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.testMinCrewIsSetDeep(filter)) return true;
    if (this.testMaxCrewIsSetDeep(filter)) return true;
    if (this.testableIsSetDeep(filter)) return true;
    if (this.ratingCategoryIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
